<div class="page-wrapper">
    <div class="content">
  
      <!-- Loading -->
      <div *ngIf="isLoading" class="loading-state">Loading trip details...</div>
  
      <div *ngIf="!isLoading">
  
        <!-- Header -->
        <div class="et-header">
          <div class="et-header-left">
            <button class="btn-back" (click)="goBack()">‹</button>
            <div>
              <div class="et-title">End Trip — {{ order?.orderNumber }}</div>
              <div class="et-subtitle">{{ order?.customerName }}</div>
            </div>
          </div>
        </div>
  
        <!-- ════════════════════════════════
             SECTION 1: Arrival Details
        ════════════════════════════════ -->
        <div class="et-card">
          <div class="et-card-header">
            <span class="step-badge step-purple">1</span>
            <h5>Arrival Details</h5>
          </div>
  
          <div class="et-card-body">
            <div class="et-form-grid">
  
              <div class="et-field">
                <label>REPORTING DATE &amp; TIME <span class="required">*</span></label>
                <input
                  type="datetime-local"
                  class="et-input"
                  [(ngModel)]="arrivalReportingDateTime" />
              </div>
  
              <div class="et-field">
                <label>UNLOADING DATE &amp; TIME <span class="required">*</span></label>
                <input
                  type="datetime-local"
                  class="et-input"
                  [(ngModel)]="arrivalUnloadingDateTime" />
              </div>
  
            </div>
  
            <!-- Days calculation banner -->
            <div class="days-banner" *ngIf="arrivalReportingDateTime && arrivalUnloadingDateTime">
              <span class="days-icon">🕐</span>
              <div>
                <div class="days-count">{{ tripDays }} {{ tripDays === 1 ? 'day' : 'days' }}</div>
                <div class="days-label">{{ tripDaysLabel }}</div>
              </div>
            </div>
          </div>
        </div>
  
        <!-- ════════════════════════════════
             SECTION 2: POD Details
        ════════════════════════════════ -->
        <div class="et-card">
          <div class="et-card-header">
            <span class="step-badge" [ngClass]="savedPods.length > 0 ? 'step-green' : 'step-purple'">2</span>
            <h5>POD Details</h5>
          </div>
  
          <div class="et-card-body">
  
            <!-- Saved PODs list -->
            <div class="no-pods-banner" *ngIf="savedPods.length === 0 && !savedPodsLoading">
              <span>📬</span> No PODs saved yet. Add one below.
            </div>
  
            <div class="saved-pods-list" *ngIf="savedPods.length > 0">
              <div class="saved-pod-item" *ngFor="let pod of savedPods">
                <span class="pod-type-chip">{{ pod.podType }}</span>
                <span class="pod-date">{{ formatApiDate(pod.podDate) }}</span>
                <span class="badge" [ngClass]="podStatusClass(pod.status)">{{ pod.status }}</span>
              </div>
            </div>
  
            <div class="et-divider"></div>
  
            <!-- POD CONDITION -->
            <div class="et-label">POD CONDITION <span class="required">*</span></div>
            <div class="pod-condition-row">
              <label class="pod-condition-option" [class.selected-clean]="podCondition === 'CLEAN'" (click)="podCondition = 'CLEAN'; podRemarks = [emptyRemark()]">
                <input type="radio" name="podCond" [checked]="podCondition === 'CLEAN'" readonly /> ✅ CLEAN
              </label>
              <label class="pod-condition-option" [class.selected-remark]="podCondition === 'REMARK'" (click)="podCondition = 'REMARK'">
                <input type="radio" name="podCond" [checked]="podCondition === 'REMARK'" readonly /> ⚠️ REMARK
              </label>
            </div>
  
            <!-- Remarks — only when REMARK selected -->
            <div class="remarks-section" *ngIf="podCondition === 'REMARK'">
              <div class="remarks-header">
                <span class="et-label">Remarks</span>
                <span class="remarks-hint">Add one or more remarks</span>
              </div>
  
              <div class="remark-block" *ngFor="let remark of podRemarks; let i = index">
                <div class="remark-title">Remark {{ i + 1 }}</div>
  
                <div class="et-label">CATEGORY <span class="required">*</span></div>
                <select class="et-input" [(ngModel)]="remark.categoryId">
                  <option [ngValue]="null" disabled>Select category</option>
                  <option *ngFor="let cat of podCategoryList" [ngValue]="cat.id">{{ cat.name || cat.categoryName }}</option>
                </select>
  
                <div class="et-form-grid mt-2">
                  <div class="et-field">
                    <label>QUANTITY <span class="required">*</span></label>
                    <input type="number" class="et-input" [(ngModel)]="remark.quantity" placeholder="0" />
                  </div>
                  <div class="et-field">
                    <label>AMOUNT (₹)</label>
                    <input type="number" class="et-input" [(ngModel)]="remark.amount" placeholder="0" />
                  </div>
                </div>
  
                <div class="et-label mt-2">COMMENT</div>
                <textarea class="et-input" rows="2" [(ngModel)]="remark.remarks" placeholder="Optional notes..."></textarea>
  
                <button class="btn-remove-remark" *ngIf="podRemarks.length > 1" (click)="removeRemark(i)">Remove</button>
              </div>
  
              <button class="btn-add-remark" (click)="addRemark()">+ Add Another Remark</button>
            </div>
  
            <!-- SOFT COPY POD -->
            <div class="pod-sub-section">
              <div class="pod-sub-header">
                <span class="pod-dot pod-dot-blue"></span>
                <span class="pod-sub-title">SOFT COPY POD</span>
              </div>
  
              <div class="et-form-grid">
                <div class="et-field">
                  <label>POD DATE <span class="required">*</span></label>
                  <input type="date" class="et-input" [(ngModel)]="softPodDate" />
                </div>
                <div class="et-field">
                  <label>UPLOAD DOCUMENT</label>
                  <label class="file-upload-btn">
                    <span *ngIf="!softPodUrl && !softPodUploading">📎 Choose file</span>
                    <span *ngIf="softPodUploading">Uploading...</span>
                    <span *ngIf="softPodUrl && !softPodUploading" class="file-uploaded">✓ Uploaded</span>
                    <input type="file" hidden accept="image/*,.pdf" (change)="onSoftPodFileSelected($event)" />
                  </label>
                </div>
              </div>
            </div>
  
            <!-- HARD COPY POD -->
            <div class="pod-sub-section">
              <div class="pod-sub-header">
                <span class="pod-dot pod-dot-amber"></span>
                <span class="pod-sub-title">HARD COPY POD</span>
              </div>
  
              <!-- Tabs: Pending / Received / Lost -->
              <div class="hard-pod-tabs">
                <button class="hard-pod-tab" [class.active]="hardPodTab === 'PENDING'" (click)="hardPodTab = 'PENDING'">
                  ⏳ Pending
                </button>
                <button class="hard-pod-tab" [class.active]="hardPodTab === 'RECEIVED'" (click)="hardPodTab = 'RECEIVED'">
                  ✅ Received
                </button>
                <button class="hard-pod-tab" [class.active]="hardPodTab === 'LOST'" (click)="hardPodTab = 'LOST'">
                  ⚠️ Lost
                </button>
              </div>
  
              <!-- Pending: no extra fields -->
              <div *ngIf="hardPodTab === 'PENDING'"></div>
  
              <!-- Received -->
              <div *ngIf="hardPodTab === 'RECEIVED'" class="hard-pod-form">
                <div class="et-label">MODE <span class="required">*</span></div>
                <select class="et-input" [(ngModel)]="hardPodMode">
                  <option [ngValue]="null" disabled>Select mode</option>
                  <option *ngFor="let m of podModeList" [ngValue]="m.id">{{ m.name || m.modeName }}</option>
                </select>
  
                <div class="et-label mt-2">SUBMISSION DATE <span class="required">*</span></div>
                <input type="date" class="et-input" [(ngModel)]="hardPodSubmissionDate" />
  
                <div class="et-label mt-2">UPLOAD HARD POD</div>
                <label class="file-upload-btn">
                  <span *ngIf="!hardPodUrl && !hardPodUploading">📎 Choose file</span>
                  <span *ngIf="hardPodUploading">Uploading...</span>
                  <span *ngIf="hardPodUrl && !hardPodUploading" class="file-uploaded">✓ Uploaded</span>
                  <input type="file" hidden accept="image/*,.pdf" (change)="onHardPodFileSelected($event)" />
                </label>
              </div>
  
              <!-- Lost -->
              <div *ngIf="hardPodTab === 'LOST'" class="hard-pod-form">
                <div class="lost-pod-warning">
                  <span class="lost-icon">⚠️</span>
                  <div>
                    <div class="lost-title">Lost POD reported.</div>
                    <div class="lost-subtitle">Indemnity bond required from vendor.</div>
                  </div>
                </div>
  
                <div class="et-label mt-3">INDEMNITY STATUS <span class="required">*</span></div>
                <div class="indemnity-options">
                  <label class="indemnity-option" [class.active]="indemnityStatus === 'RECEIVED'" (click)="indemnityStatus = 'RECEIVED'">
                    <input type="radio" name="indemnity" [checked]="indemnityStatus === 'RECEIVED'" readonly />
                    Yes — Received
                  </label>
                  <label class="indemnity-option" [class.active]="indemnityStatus === 'PENDING'" (click)="indemnityStatus = 'PENDING'">
                    <input type="radio" name="indemnity" [checked]="indemnityStatus === 'PENDING'" readonly />
                    No / Indemnity Pending — Not yet received from vendor.
                  </label>
                </div>
              </div>
  
              <!-- Save Hard POD button -->
              <button class="btn-save-hard-pod" [disabled]="hardPodSaving" (click)="saveHardPod()">
                💾 {{ hardPodSaving ? 'Saving...' : 'Save Hard POD' }}
              </button>
            </div>
  
            <!-- Save POD Details button -->
            <button class="btn-save-pod" [disabled]="podSaving" (click)="savePodDetails()">
              💾 {{ podSaving ? 'Saving...' : 'Save POD Details' }}
            </button>
  
          </div>
        </div>
  
        <!-- ════════════════════════════════
             SECTION 3: Additional Charges
        ════════════════════════════════ -->
        <div class="et-card">
          <div class="et-card-header">
            <span class="step-badge step-amber">3</span>
            <h5>Additional Charges</h5>
          </div>
  
          <div class="et-card-body">
  
            <!-- Saved charges list -->
            <div class="saved-charges-list" *ngIf="savedCharges.length > 0">
              <div class="saved-charge-item" *ngFor="let sc of savedCharges">
                <span class="charge-name">{{ sc.chargeTypeName }}</span>
                <span class="charge-amount">₹{{ sc.charge }}</span>
                <span class="charge-alloc">
                  <span *ngIf="sc.chargeToCustomer">→ Customer</span>
                  <span *ngIf="sc.chargeToVendor"> &amp; Vendor</span>
                </span>
              </div>
            </div>
  
            <!-- Charge form rows -->
            <div class="charge-block" *ngFor="let charge of charges; let ci = index">
              <div class="charge-block-title">ADD CHARGE</div>
  
              <div class="et-form-grid">
                <div class="et-field">
                  <label>TYPE</label>
                  <select class="et-input" [(ngModel)]="charge.chargeTypeId" (change)="onChargeTypeChange(charge, $event)">
                    <option [ngValue]="null" disabled>Select</option>
                    <option *ngFor="let ct of chargeTypeList" [ngValue]="ct.id">{{ ct.name || ct.chargeName }}</option>
                  </select>
                </div>
                <div class="et-field">
                  <label>AMOUNT (₹) <span class="required">*</span></label>
                  <input type="number" class="et-input" [(ngModel)]="charge.charge" placeholder="0" />
                </div>
              </div>
  
              <div class="et-form-grid mt-2">
                <div class="et-field">
                  <label>DOCUMENT</label>
                  <label class="file-upload-btn">
                    <span *ngIf="!charge.docUrl && !charge.uploading">📎 Choose file</span>
                    <span *ngIf="charge.uploading">Uploading...</span>
                    <span *ngIf="charge.docUrl && !charge.uploading" class="file-uploaded">✓ {{ charge.docUrl.split('/').pop() }}</span>
                    <input type="file" hidden accept="image/*,.pdf" (change)="onChargeFileSelected($event, charge)" />
                  </label>
                </div>
                <div class="et-field">
                  <label>REMARKS</label>
                  <input type="text" class="et-input" [(ngModel)]="charge.remarks" placeholder="Optional" />
                </div>
              </div>
  
              <!-- Charge Allocation -->
              <div class="et-label mt-2">CHARGE ALLOCATION <span class="required">*</span></div>
              <div class="alloc-hint">Both can be selected if applicable.</div>
              <div class="alloc-row">
                <label class="alloc-check">
                  <input type="checkbox" [(ngModel)]="charge.chargeToCustomer" /> Charged to Customer
                </label>
                <label class="alloc-check">
                  <input type="checkbox" [(ngModel)]="charge.chargeToVendor" /> Paid to Vendor
                </label>
              </div>
  
              <!-- Vendor Charge — only when Paid to Vendor is checked -->
              <div *ngIf="charge.chargeToVendor" class="et-field mt-2">
                <label>VENDOR CHARGE (₹) <span class="required">*</span></label>
                <input type="number" class="et-input" [(ngModel)]="charge.vendorCharge" placeholder="0" />
              </div>
  
              <button class="btn-add-charge" [disabled]="charge.saving" (click)="saveCharge(charge)">
                {{ charge.saving ? 'Saving...' : '+ Add Charge' }}
              </button>
            </div>
  
          </div>
        </div>
  
        <!-- ════════════════════════════════
             CLOSE TRIP REQUIREMENTS
        ════════════════════════════════ -->
        <div class="close-requirements" *ngIf="!canCloseTrip()">
          <span class="req-icon">💡</span>
          <div>
            <div class="req-title">To close this trip, you need:</div>
            <div class="req-item">• At least one saved POD</div>
          </div>
        </div>
  
        <!-- Close Trip -->
        <button
          class="btn-close-trip"
          *ngIf="canCloseTrip()"
          [disabled]="closingTrip"
          (click)="closeTrip()">
          {{ closingTrip ? 'Closing...' : '🚩 Close Trip' }}
        </button>
  
      </div>
    </div>
  </div>